module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "special-days text-dark"
  }, [_c('div', {
    staticClass: "special-days__header"
  }, [_c('div', {
    staticClass: "special-days__header__text"
  }, [_c('div', {
    staticClass: "special-days__header__title-row"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.special_days.title')))]), _vm._v(" "), _c('ChangeSchoolYear', {
    attrs: {
      "whiteTheme": true
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "do-pill do-pill--yellow special-days__intro"
  }, [_vm._v("Der kopieres ikke ind i datoer i klasseskemaerne med omlagte dage, og de overskrives derfor ikke. Omlagte dage kan desuden fratrække uv-timer fra klassens normale fagtimer, der skulle have lagt.")])]), _vm._v(" "), _c('div', {
    staticClass: "special-days__header__actions"
  }, [_c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--loading': _vm.isRefreshingReductions
    },
    attrs: {
      "disabled": !_vm.canCreate || _vm.isRefreshingReductions
    },
    on: {
      "click": _vm.refreshReductions
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.special_days.refresh_reductions')) + "\n      ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'bottom',
        allowHTML: true
      }),
      expression: "{arrow: true, placement: 'bottom', allowHTML: true}"
    }],
    staticClass: "do-bttn do-bttn--submit",
    attrs: {
      "disabled": !_vm.canCreate,
      "content": _vm.shortcutTooltip
    },
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.special_days.create')) + "\n      ")])])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader') : [_c('table', {
    staticClass: "do-table do-table--striped special-days__table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('vue2.special_days.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('vue2.special_days.period')))]), _vm._v(" "), _c('th', {
    staticClass: "special-days__table__classes-col"
  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.classes')))]), _vm._v(" "), _c('th', {
    staticClass: "special-days__table__reduct-col"
  }, [_vm._v("Reducer")]), _vm._v(" "), _c('th', {
    staticClass: "special-days__table__actions-col"
  })])]), _vm._v(" "), _c('tbody', [(_vm.specialDays.length === 0) ? _c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.none_created')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.specialDays), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "special-days__row",
      on: {
        "click": function($event) {
          return _vm.openEdit(item)
        }
      }
    }, [_c('td', {
      staticClass: "special-days__table__name"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatPeriod(item)))]), _vm._v(" "), _c('td', {
      staticClass: "special-days__table__classes-col"
    }, [_vm._v(_vm._s(_vm.classNames(item)))]), _vm._v(" "), _c('td', {
      staticClass: "special-days__table__reduct-col"
    }, [(item.reduct) ? _c('span', {
      staticClass: "special-days__reduct-days"
    }, [_vm._v(_vm._s(_vm.reductDaysLabel(item)))]) : _c('span', {
      staticClass: "special-days__reduct-dash"
    }, [_vm._v("–")])]), _vm._v(" "), _c('td', {
      staticClass: "special-days__table__actions",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(_vm.linkedSubjects(item).length === 0) ? _c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'bottom',
          allowHTML: true
        }),
        expression: "{arrow: true, placement: 'bottom', allowHTML: true}"
      }],
      staticClass: "do-bttn do-bttn--small",
      attrs: {
        "aria-label": "Opret brikker",
        "content": 'Opret brikker'
      },
      on: {
        "click": function($event) {
          return _vm.openSubjects(item)
        }
      }
    }, [_vm._v("\n              Opret brikker\n            ")]) : _c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'bottom',
          allowHTML: true
        }),
        expression: "{arrow: true, placement: 'bottom', allowHTML: true}"
      }],
      staticClass: "do-bttn do-bttn--small",
      attrs: {
        "content": 'Se og rediger brikker'
      },
      on: {
        "click": function($event) {
          return _vm.openSubjectsList(item, $event)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.brikkerLabel(item)) + "\n            ")]), _vm._v(" "), _c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'bottom',
          allowHTML: true
        }),
        expression: "{arrow: true, placement: 'bottom', allowHTML: true}"
      }],
      staticClass: "do-bttn do-bttn--small",
      attrs: {
        "aria-label": _vm.$t('vue2.special_days.edit'),
        "content": 'Rediger omlagt dag'
      },
      on: {
        "click": function($event) {
          return _vm.openEdit(item)
        }
      }
    }, [_c('span', {
      staticClass: "icon-pencil"
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'bottom',
          allowHTML: true
        }),
        expression: "{arrow: true, placement: 'bottom', allowHTML: true}"
      }],
      staticClass: "do-bttn do-bttn--small do-bttn--danger",
      attrs: {
        "aria-label": _vm.$t('vue2.special_days.delete'),
        "content": 'Slet omlagt dag'
      },
      on: {
        "click": function($event) {
          return _vm.confirmDelete(item)
        }
      }
    }, [_c('span', {
      staticClass: "icon-bin"
    })])])])
  })], 2)])], _vm._v(" "), (_vm.isModalOpen) ? _c('SpecialDayModal', {
    attrs: {
      "schoolId": _vm.schoolId,
      "schoolYearId": _vm.schoolYearId,
      "specialDayId": _vm.editingId,
      "klassCalendars": _vm.klassCalendars,
      "defaultDate": _vm.schoolYearStartDate
    },
    on: {
      "saved": _vm.onSaved,
      "close": _vm.closeModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subjectsForDay) ? _c('SpecialDaySubjectsModal', {
    attrs: {
      "schoolId": _vm.schoolId,
      "schoolYearId": _vm.schoolYearId,
      "specialDay": _vm.subjectsForDay,
      "klassCalendars": _vm.klassCalendars,
      "existingSubjects": _vm.linkedSubjects(_vm.subjectsForDay)
    },
    on: {
      "created": _vm.onSubjectsCreated,
      "close": function($event) {
        _vm.subjectsForDay = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subjectsListForDay) ? _c('SpecialDaySubjectsListModal', {
    attrs: {
      "schoolId": _vm.schoolId,
      "schoolYearId": _vm.schoolYearId,
      "specialDay": _vm.subjectsListForDay,
      "klassCalendars": _vm.klassCalendars
    },
    on: {
      "changed": _vm.onSubjectsChanged,
      "create": _vm.openSubjectsFromList,
      "close": function($event) {
        _vm.subjectsListForDay = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCalModalOpen) ? _c('SpecialDayCalendarModal', {
    attrs: {
      "schoolId": _vm.schoolId,
      "schoolYearId": _vm.schoolYearId,
      "specialDayId": _vm.editingId,
      "klassCalendars": _vm.klassCalendars,
      "schoolYearStart": _vm.schoolYearStartDate,
      "schoolYearEnd": _vm.schoolYearEndDate
    },
    on: {
      "saved": _vm.onCalSaved,
      "close": _vm.closeCalModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.deleting) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false,
      "isShowConfirmDeleteMessage": false,
      "isSubmitButtonLoading": _vm.isDeleting
    },
    on: {
      "confirm": _vm.runDelete,
      "close": function($event) {
        _vm.deleting = null
      }
    }
  }, [_c('template', {
    slot: "item"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('vue2.special_days.confirm_delete_title')) + " " + _vm._s(_vm.deleting.title) + "?")]), _vm._v(" "), _c('p', {
    staticClass: "special-days__confirm-text"
  }, [_vm._v(_vm._s(_vm.formatPeriod(_vm.deleting)))]), _vm._v(" "), (_vm.linkedSubjects(_vm.deleting).length > 0) ? _c('div', {
    staticClass: "special-days__confirm-subjects"
  }, [_c('p', {
    staticClass: "special-days__confirm-subjects__label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.linked_subjects')))]), _vm._v(" "), _c('table', {
    staticClass: "special-days__confirm-subjects__table"
  }, [_c('tbody', _vm._l((_vm.linkedSubjects(_vm.deleting)), function(subject) {
    return _c('tr', {
      key: subject.id,
      staticClass: "special-days__confirm-subjects__row",
      class: {
        'special-days__confirm-subjects__row--disabled': !_vm.canDeleteSubject(subject)
      },
      on: {
        "click": function($event) {
          return _vm.toggleSubjectToDelete(subject)
        }
      }
    }, [_c('td', {
      staticClass: "special-days__confirm-subjects__check"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.canDeleteSubject(subject)
      },
      domProps: {
        "checked": _vm.subjectsToDelete.indexOf(subject.id) > -1
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        },
        "change": function($event) {
          return _vm.toggleSubjectToDelete(subject)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "special-days__confirm-subjects__name"
    }, [_c('span', {
      staticClass: "special-days__confirm-subjects__dot",
      style: ({
        backgroundColor: subject.color
      })
    }), _vm._v("\n                " + _vm._s(subject.name) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "special-days__confirm-subjects__note"
    }, [(!_vm.canDeleteSubject(subject)) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.special_days.subject_cannot_delete')))]) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "special-days__confirm-subjects__hint"
  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.subjects_delete_hint')))])]) : _vm._e()]), _vm._v(" "), _c('template', {
    slot: "confirmText"
  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.delete')))])], 2) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ac764cac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SpecialDays/SpecialDays.vue
// module id = 2087
// module chunks = 1